import { AutogenModelCommitmentAutoRating, AutogenRowCommitmentAutoRating } from "./autogen/AutogenModelCommitmentAutoRating";

export class ModelCommitmentAutoRating extends AutogenModelCommitmentAutoRating<RowCommitmentAutoRating> {
    constructor() {
        super(RowCommitmentAutoRating);
    }
}

export class RowCommitmentAutoRating extends AutogenRowCommitmentAutoRating {
}